import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'

export function GeneralDataProtectionRegulation() {
  const { privacy, marketingPreferences } = useConfiguration('links')
  const intl = useIntl()

  return (
    <Typography
      variant="body-m-regular-tight"
    >
      {intl.formatMessage(
        { id: 'checkout_steps_gdpr_consent' },
        {
          privacyLink: (chunks: (string | React.JSX.Element)[]) => <a href={privacy} target="_blank" rel="noopener noreferrer">{chunks}</a>,
          marketingPreferencesLink: (chunks: (string | React.JSX.Element)[]) => <a href={marketingPreferences} target="_blank" rel="noopener noreferrer">{chunks}</a>,
        },
      )}
    </Typography>
  )
}
